<template>
  <div class="app-container">
    <el-card>
      <div style="float: left;width: 260px;">
        <el-form size="small">
        <el-form-item>
          <el-select v-model="queryForm.orderType" style="width: 100%;">
            <!-- 揽收订单号 -->
            <el-option :label="$t('collectionCenter.lanshouOrderNum')" :value="0" />
            <!-- 条形码 -->
            <el-option :label="$t('collectionCenter.Barcode')" :value="1" />
            <!-- 包裹号 -->
            <el-option :label="$t('collectionCenter.parcelNum')" :value="2" />
            <!-- 袋号 -->
            <el-option :label="$t('collectionCenter.BagNumber')" :value="3" />
            <!-- 车牌号 -->
            <el-option :label="$t('collectionCenter.licensePlateNumber')" :value="4" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="queryForm.orderNum" :placeholder="$t('collectionCenter.BatchQuery')" type="textarea"
            :rows="20"
          />
        </el-form-item>
        <el-form-item>
          <!-- 查询 -->
          <el-button
            v-permit:remove="'btn:collection-center:order:track-query:find'"
            type="primary"
            icon="el-icon-search"
            size="small"
            :disabled="isNoSubmit"
            @click="defaultClick"
          >{{ $t('collectionCenter.search') }}</el-button>
          <!-- 重置 -->
          <el-button size="small" icon="el-icon-refresh-right" @click="resetClick">{{ $t('collectionCenter.reset') }} </el-button>
        </el-form-item>
      </el-form>
      </div>
    <div style="float: left;width: calc(100% - 260px);">
      <div class="track-container">
        <el-tabs v-model="activeName" :scrollable="{arrowVisible: true, minItemWidth: '80px'}">
          <el-tab-pane label="全部" name="1">
            <template slot="label">
              <div style="font-weight: bold;color: #000000;">
                <i style="margin-right: 5px;float: left">all</i>
                {{ $t('collectionCenter.tudo') }}（{{ dataList.all.num }}）
              </div>
            </template>
            <track-detail
              v-if="activeName === '1'"
              :key="activeName"
              :track-data="dataList.all.list"
            />
          </el-tab-pane>
          <el-tab-pane label="揽收" name="2">
            <template slot="label">
              <div style="font-weight: bold;color: #00A551;">
                <i class="iconfont icon-saoma" style="margin-right: 5px;float: left" />
                {{ $t('collectionCenter.lanshou') }}（{{ dataList.collection.num }}）
              </div>
            </template>
            <track-detail
              v-if="activeName === '2'"
              :key="activeName"
              :track-data="dataList.collection.list"
            />
          </el-tab-pane>
          <el-tab-pane label="问题件" name="3">
            <template slot="label">
              <div style="font-weight: bold;color: #F56C6C;">
                <i class="iconfont icon-yichangtishi" style="margin-right: 5px;float: left" />
                {{ $t('collectionCenter.ProblemPiece') }}（{{ dataList.problematic.num }}）
              </div>
            </template>
            <track-detail
              v-if="activeName === '3'"
              :key="activeName"
              :track-data="dataList.problematic.list"
            />
          </el-tab-pane>
          <el-tab-pane label="封袋" name="4">
            <template slot="label">
              <div style="font-weight: bold;color: #f5bc17;">
                <i class="iconfont icon-fangkuangweixuan" style="margin-right: 5px;float: left" />
                {{ $t('collectionCenter.SealingBags') }}（{{ dataList.sealedBag.num }}）
              </div>
            </template>
            <track-detail
              v-if="activeName === '4'"
              :key="activeName"
              :track-data="dataList.sealedBag.list"
            />
          </el-tab-pane>
          <el-tab-pane label="装车" name="5">
            <template slot="label">
              <div style="font-weight: bold;color: #20a8b0;">
                <i class="iconfont icon-a-391347311" style="margin-right: 5px;float: left" />
                {{ $t('collectionCenter.status6') }}（{{ dataList.loaded.num }}）
              </div>
            </template>
            <track-detail
              v-if="activeName === '5'"
              :key="activeName"
              :track-data="dataList.loaded.list"
            />
          </el-tab-pane>
          <el-tab-pane label="卸车" name="6">
            <template slot="label">
              <div style="font-weight: bold;color: #b00e85;">
                <i class="iconfont icon-a-391347312" style="margin-right: 5px;float: left" />
                {{ $t('collectionCenter.status7') }}（{{ dataList.unloaded.num }}）
              </div>
            </template>
            <track-detail
              v-if="activeName === '6'"
              :key="activeName"
              :track-data="dataList.unloaded.list"
            />
          </el-tab-pane>
          <el-tab-pane label="签收" name="7">
            <template slot="label">
              <div style="font-weight: bold;color: #67C23A;">
                <i class="iconfont icon-qianshou" style="margin-right: 5px;float: left" />
                {{ $t('collectionCenter.signFor') }}（{{ dataList.signFor.num }}）
              </div>
            </template>
            <track-detail
              v-if="activeName === '7'"
              :key="activeName"
              :track-data="dataList.signFor.list"
            />
          </el-tab-pane>
          <el-tab-pane label="已闭环" name="8">
            <template slot="label">
              <div style="font-weight: bold;color: #c72121;">
                <i class="iconfont icon-quanbuxunhuan" style="margin-right: 5px;float: left" />
                {{ $t('collectionCenter.closedLoop') }}（{{ dataList.closedLoop.num }}）
              </div>
            </template>
            <track-detail
              v-if="activeName === '8'"
              :key="activeName"
              :track-data="dataList.closedLoop.list"
            />
          </el-tab-pane>
          <el-tab-pane label="其他" name="9">
            <template slot="label">
              <div style="font-weight: bold;color: #909399;">
                <i class="iconfont icon-shalou" style="margin-right: 5px;float: left" />
                {{ $t('collectionCenter.other') }}（{{ dataList.other.num }}）
              </div>
            </template>
            <track-detail
              v-if="activeName === '9'"
              :key="activeName"
              :track-data="dataList.other.list"
            />
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    </el-card>
  </div>
</template>
<script>
import { trackQuery } from '@/api/lanshou';

export default {
  name: 'TrackQuery',
  components: {
    trackDetail: () => import('./cmp/trackDetail.vue')
  },
  data() {
    return {
      queryForm: {
        orderType: 0,
        orderNum: ''
      },
      activeName: '1',
      dataList: {
        all: {
          num: 0,
          list: []
        },
        collection: {
          num: 0,
          list: []
        },
        sealedBag: {
          num: 0,
          list: []
        },
        loaded: {
          num: 0,
          list: []
        },
        unloaded: {
          num: 0,
          list: []
        },
        signFor: {
          num: 0,
          list: []
        },
        closedLoop: {
          num: 0,
          list: []
        },
        problematic: {
          num: 0,
          list: []
        },
        other: {
          num: 0,
          list: []
        }
      },
      isNoSubmit: false
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.fixTabScroll();
    });
  },
  methods: {
    fixTabScroll() {
      const tabNav = this.$refs.tabs?.navWrapRef;
      if (tabNav) {
        tabNav.addEventListener('wheel', this.handleTabWheel, { passive: false });
      }
    },
    handleTabWheel(e) {
      e.preventDefault();
      const container = e.currentTarget;
      container.scrollLeft += e.deltaY;
    },
    dataCont() {
      this.dataList = {
        all: {
          num: 0,
          list: []
        },
        collection: {
          num: 0,
          list: []
        },
        sealedBag: {
          num: 0,
          list: []
        },
        loaded: {
          num: 0,
          list: []
        },
        unloaded: {
          num: 0,
          list: []
        },
        signFor: {
          num: 0,
          list: []
        },
        closedLoop: {
          num: 0,
          list: []
        },
        problematic: {
          num: 0,
          list: []
        },
        other: {
          num: 0,
          list: []
        }
      };
    },
    // 数据归类
    dataClassification(type, data) {
      console.log(type, '===type====');
      if (type === 1) { // '揽收'
        data.trackIcon = 'iconfont icon-saoma color-brand-primary';
        this.dataList.collection.list.push(data);
      } else if (type === 2) { // '异常'
        data.trackIcon = 'iconfont icon-yichangtishi color-F56C6C';
        this.dataList.problematic.list.push(data);
      } else if (type === 3) { // '封袋'
        data.trackIcon = 'iconfont icon-fangkuangweixuan color-f5bc17';
        this.dataList.sealedBag.list.push(data);
      } else if (type === 4) { // '装车'
        data.trackIcon = 'iconfont icon-a-391347311 color-20a8b0';
        this.dataList.loaded.list.push(data);
      } else if (type === 5) { // '卸车'
        data.trackIcon = 'iconfont icon-a-391347312 color-b00e85';
        this.dataList.unloaded.list.push(data);
      } else if (type === 6) { // '签收'
        data.trackIcon = 'iconfont icon-qianshou color-67C23A';
        this.dataList.signFor.list.push(data);
      } else if (type === 7) { // '闭环'
        data.trackIcon = 'iconfont icon-quanbuxunhuan color-c72121';
        this.dataList.closedLoop.list.push(data);
      } else {
        data.trackIcon = 'iconfont icon-shalou color-909399';
        this.dataList.other.list.push(data);
      }
    },
    // 获取轨迹数据
    defaultClick() {
      this.queryForm.pageNumber = 1;
      this.getTrackData();
    },
    getTrackData() {
      this.isNoSubmit = true;
      const param = {
        number: this.queryForm.orderType,
        numbers: []
      };
      if (this.queryForm.orderNum.length > 0) {
        const num = [...new Set(this.queryForm.orderNum.split(/\r?\n/).map(item => item.replace(/\s+/g, '')).filter(item => Boolean(item)))];
        if (num.length > 50) {
          this.$message.warning(this.$t('collectionCenter.intercept50')); // '单次查询最多50条，已截取前50条数据'
          param.numbers = num.slice(0, 50);
          this.queryForm.orderNum = num.slice(0, 50).join('\n');
        } else {
          param.numbers = num;
        }
      } else {
        this.$message.warning(this.$t('collectionCenter.inputNumFind')); // '请在文本框内输入单号进行查询'
        this.isNoSubmit = false;
        return;
      }
      // 清空查询到的数据
      this.dataCont();
      trackQuery(param).then(res => {
        if (res.code === 200) {
          this.dataList.collection.num = res.data.collectNum;
          this.dataList.sealedBag.num = res.data.bagNum;
          this.dataList.loaded.num = res.data.loadNum;
          this.dataList.unloaded.num = res.data.unloadedNum;
          this.dataList.signFor.num = res.data.signNum;
          this.dataList.closedLoop.num = res.data.closeNum;
          this.dataList.problematic.num = res.data.abnormalNum;
          this.dataList.other.num = res.data.otherNum;
          this.dataList.all.num = res.data.collectNum + res.data.bagNum + res.data.loadNum + res.data.unloadedNum + res.data.signNum + res.data.closeNum + res.data.abnormalNum + res.data.otherNum;
          const allNum = [];
          if (res.data.collectTrackList && res.data.collectTrackList.length > 0) {
            res.data.collectTrackList.map(item => {
              if (item.nowTrack && item.nowTrack.length > 0) {
                this.dataClassification(item.nowTrack[0].statusType, item);
                this.dataList.all.list.push(item);
              } else if (item.vehicleNowTrack && item.vehicleNowTrack.length > 0) {
                this.dataClassification(item.vehicleNowTrack[0].statusType, item);
                this.dataList.all.list.push(item);
              }
              if ((item.nowTrack && item.nowTrack.length > 0) || (item.vehicleNowTrack && item.vehicleNowTrack.length > 0)) {
                allNum.push(item.number);
              }
            });
            // 找出 param.numbers 中有但 allNum 中没有的数据
            const diff1 = param.numbers.filter(item => !allNum.includes(item));
            diff1.map(item => {
              const data = {
                number: item,
                nowTrack: [],
                vehicleNowTrack: [],
                trackIcon: 'iconfont icon-shalou color-909399'
              };
              if (this.queryForm.orderType === 4) {
                data.vehicleNowTrack = [{
                  status: this.$t('orderCenterCont.NotFound') // '无数据'
                }];
              } else {
                data.nowTrack = [{
                  status: this.$t('orderCenterCont.NotFound') // '无数据'
                }];
              }
              this.dataList.other.num += 1;
              this.dataList.other.list.push(data);
              this.dataList.all.num += 1;
              this.dataList.all.list.push(data);
            });
          } else {
            param.numbers.map(item => {
              const data = {
                number: item,
                nowTrack: [],
                vehicleNowTrack: [],
                trackIcon: 'iconfont icon-shalou color-909399'
              };
              if (this.queryForm.orderType === 4) {
                data.vehicleNowTrack = [{
                  status: this.$t('orderCenterCont.NotFound') // '无数据'
                }];
              } else {
                data.nowTrack = [{
                  status: this.$t('orderCenterCont.NotFound') // '无数据'
                }];
              }
              this.dataList.other.num += 1;
              this.dataList.other.list.push(data);
              this.dataList.all.num += 1;
              this.dataList.all.list.push(data);
            });
          }
          console.log(this.dataList, '===this.dataList====');
          this.isNoSubmit = false;
        }
      }).catch(() => {
        this.isNoSubmit = false;
      });
    },
    // 重置
    resetClick() {
      this.queryForm.orderNum = '';
      this.queryForm.orderType = 0;
      // 清空查询到的数据
      this.dataCont();
    }
  }
};
</script>

<style>
.track-container {
  margin-left: 10px;
  border: 1px solid #ccc;
  height: calc(100vh - 100px);
  border-radius: 3px;
  padding: 10px;
  overflow: hidden;
}
.el-tabs--top .el-tabs__nav-wrap::after,
.el-tabs--bottom .el-tabs__nav-wrap::after {
  height: 0 !important;
}
.track-container .el-tabs__nav-wrap {
  overflow-x: auto !important;
  scrollbar-width: thin;
  border-bottom: 2px solid #ccc;
}
.track-container .el-tabs__nav-scroll {
  display: flex;
  min-width: max-content;
}
.track-container .el-tabs__nav-next,
.track-container .el-tabs__nav-prev {
  line-height: 40px;
  font-size: 14px;
  background: #ddd;
  color: #000;
  cursor: pointer;
  user-select: none;
  flex-shrink: 0;
  width: 30px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.track-container .el-tabs__item {
  padding: 0 10px;
  white-space: nowrap;
  flex-shrink: 0;
}
</style>
